import { render } from "./designRadioPreview.vue?vue&type=template&id=ac4885b8&scoped=true"
import script from "./designRadioPreview.vue?vue&type=script&lang=js"
export * from "./designRadioPreview.vue?vue&type=script&lang=js"

import "./designRadioPreview.vue?vue&type=style&index=0&id=ac4885b8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac4885b8"]])

export default __exports__